::Object.require 'opal/base'

::Object.require 'corelib/nil'
::Object.require 'corelib/boolean'
::Object.require 'corelib/string'
::Object.require 'corelib/comparable'
::Object.require 'corelib/enumerable'
::Object.require 'corelib/enumerator'
::Object.require 'corelib/array'
::Object.require 'corelib/hash'
::Object.require 'corelib/number'
::Object.require 'corelib/range'
::Object.require 'corelib/proc'
::Object.require 'corelib/method'
::Object.require 'corelib/regexp'
::Object.require 'corelib/variables'
::Object.require 'corelib/io'
::Object.require 'opal/regexp_anchors'
